import React, { useEffect, useState } from "react";
import { getCurrentLangName } from "helpers/String.helper";
import { getCountryCodeList } from "data/common.data";
import { getLanguageValue } from "locales/i18n";

import StudentList from "./ApplyingRequestList";

const Home = () => {
    const [keyword, setKeyword] = useState("");
    const [hasSearch, setHasSearch] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [searchFilter, setSearchFilter] = useState({
        countryCodeList: [],
        genderTypeCode: "",
        minAge: 0,
        maxAge: 99,
        minWeight: 0,
        maxWeight: 999,
        minHeight: 0,
        maxHeight: 999
    });

    
    const onSearchFilter = (key: string, value: any) => {
        setSearchFilter(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const onDeleteCountryCode = (code: string) => {
        setSearchFilter(prev => ({
            ...prev,
            countryCodeList: prev.countryCodeList.filter(c => c !== code)
        }));
    };



    return (
        <main className="flex flex-col min-h-screen bg-gray-50">
            <div className="container mx-auto px-4 py-6">
                {/* 학생 목록 영역 */}
                <StudentList />
            </div>
        </main>
    );
};

export default Home;